import Accordion from "components/core/basic/Accordion";
import Card from "components/core/basic/Card";
import { Flex } from "../../../../styled-system/jsx";
import { useMutation } from "@tanstack/react-query";
import api from "utils/api";
import { successToast, errorToast } from "utils/toasts";
import { Button } from "components/core/basic/Button";
import { css } from "../../../../styled-system/css";
import { useState } from "react";
import { NumberInput } from "components/fields/base/NumberInput";

type Props = {
  currentShelfLimit?: number;
};

const DigitalShelfSection = ({ currentShelfLimit = 0 }: Props) => {
  const [updatedShelfLimitCount, setUpdatedShelfLimitCount] = useState(currentShelfLimit);

  const updateShelfLimitHandler = useMutation({
    mutationFn: async () => {
      return await api.patch("/api/update_org_shelf_count/", {
        updated_shelf_count: updatedShelfLimitCount,
      });
    },

    onSuccess: () => {
      successToast({
        message: "Digital Shelf Credits Successfully Updated.",
      });
    },

    onError: (error) => {
      errorToast({
        message: "Failed to Update Shelf Credit",
        error,
      });
    },
  });

  return (
    <Accordion title={"Digital Shelf Credits"}>
      <Card>
        <Flex
          className={css({ width: "250px", padding: "large" })}
          gap="small"
          direction={"column"}
          justifyContent="center"
        >
          <NumberInput
            label={"New Digital Shelf Limit"}
            value={updatedShelfLimitCount}
            onChange={(value) => setUpdatedShelfLimitCount(value)}
          />
          <Button onPress={() => updateShelfLimitHandler.mutate()}>Update</Button>
        </Flex>
      </Card>
    </Accordion>
  );
};

export default DigitalShelfSection;
